export default __webpack_public_path__ + "static/plug_w.1baf08646b1e0df0b40efe9e0a23b758.png";